export default __webpack_public_path__ + "static/media/teta-logo.e358e35e.png";